var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-pagination',{ref:"pages",staticClass:"pages-center",attrs:{"current-page":_vm.currentPage,"layout":"prev, pager, next, jumper,slot","total":_vm.total},on:{"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }